export const PAGE_BREAKPOINTS = {
    mobile: 'screen and (max-width: 37.438em)', // less than 600px
    desktop: 'screen and (min-width: 33.5em)', // more than 600px; could:  and (max-width: 63.9375em)
    desk: 'screen and (min-width: 53.125em)', // more than 850px
    retina: '(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx)',
};
